export default __webpack_public_path__ + "static/media/487.aa6d4461.png";